export default __webpack_public_path__ + "static/media/error.37ff977e.svg";